import {Icon} from '@iconify/react';
import React, {PropsWithChildren} from 'react';
import {ELEMENT} from '../../incase-domain/elements/base/ElementTypes';

interface ElementBoxProps {
    icon: string;
    element: string;
    type: ELEMENT;
    onMouseUp?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function ElementBox(props: PropsWithChildren<ElementBoxProps>): JSX.Element {
    const {icon, element, type, onMouseUp} = props;

    return (
        <button onMouseUp={onMouseUp} type="button" data-cy={type} className="c-elementBox u-flex u-flex-col u-h-center u-v-center u-gap-2">
            <Icon icon={icon} className="c-elementBox_icon" />
            <div className="c-elementBox_elementName">{element}</div>
        </button>
    );
}

export default ElementBox;
